<template>
    <div class="calendar calendar--inline">
        <div v-if="isLoading" class="calendar-loading">
            <div class="calendar-spinner"></div>
        </div>
        <template v-else>
        <button class="calendar-btn calendar-btn--prev" v-on:click="onCalendarPrev()">-</button>
        <ul ref="calendarUl">
            <li v-for="calendarDay in calendarDays"
                v-on:click="onClickDate(calendarDay.Date)"
                v-bind:key="calendarDay.Date"
                v-bind:class="getCssClass(calendarDay)">
                <span class="calendar-date">{{formatDate(calendarDay.Date)}}</span>
                <span v-if="calendarDay.IsAvailable" class="calendar-price">&pound;{{priceFormatted(calendarDay.Amount)}}</span>
                <span v-if="!calendarDay.IsAvailable" class="calendar-price">-</span>
            </li>

        </ul>
        <button class="calendar-btn calendar-btn--next" v-on:click="onCalendarNext()">
            +
        </button>
        </template>
        <Teleport to="body">
            <div v-if="arrivalMlos && tooltipStyle" class="calendar-mlos" :style="tooltipStyle">
                Minimum {{ arrivalMlos }}-night stay required
            </div>
        </Teleport>
    </div>
</template>

<script>
    import { store } from '../store/index';
    import moment from 'moment';

    export default {
        name: 'RoomCalendar',
        props: {
            roomType: Object,
            leg: String
        },
        computed: {
            booking() {
                return store.getters.booking;
            },
            session() {
                return store.getters.session;
            },
            search() {
                return store.getters.search;
            },
            arrivalMlos() {
                if (!this.calendarDays) return null;
                const arrival = this.calendarDays.find(d => this.isArrivalDate(d.Date));
                return (arrival && arrival.MinLengthOfStay > 1) ? arrival.MinLengthOfStay : null;
            },
            arrivalDayIndex() {
                if (!this.calendarDays) return -1;
                return this.calendarDays.findIndex(d => this.isArrivalDate(d.Date));
            },
            tooltipStyle() {
                if (!this.tooltipAnchor) return null;
                return {
                    top: this.tooltipAnchor.top + 'px',
                    left: this.tooltipAnchor.left + 'px'
                };
            },
            isEnabled() {
                return this.leg == '1';
            },
            calendarDays() {
                var roomCode = this.roomType.PMSCode;
                let roomCalendar = store.getters.roomCalendar(roomCode);

                if (roomCalendar != undefined) {
                    return roomCalendar.slice(0, 7);
                }
                console.log("roomCalendar", roomCalendar);
                return roomCalendar;

            },
            arrivalDate() {
                let result = null;
                if (this.newArrivalDate != null) {
                    var arrivalDate = moment(this.newArrivalDate);
                    result = arrivalDate;
                }
                else {
                    var search = store.getters.search;
                    var arrivalDate = moment(search.arrivalDate);
                    result = arrivalDate
                }

                return moment(moment(result).format("YYYY-MM-DD"));

            },
            seedDate() {
                var search = store.getters.search;
                var date = moment(search.arrivalDate).add(-1, 'd');
                return date;
            },
            departureDate() {
                var result = null;
                if (this.newDepartureDate != null) {
                    let departureDate = moment(this.newDepartureDate);
                    result = departureDate ;
                }
                else {

                    var search = store.getters.search;
                    var arrivalDate = search.arrivalDate;
                    result= moment(arrivalDate).add(+search.numberOfNights, 'd');
                }

                return moment(moment(result).format("YYYY-MM-DD"));


            }
        },
        data() {
            return {
                newArrivalDate: null,
                newDepartureDate: null,
                isLoading: true,
                tooltipAnchor: null
            }
        },
        watch: {
            calendarDays(val) {
                if (val != null && val.length > 0) {
                    this.isLoading = false;
                }
                this.$nextTick(this.computeTooltipAnchor);
            },
            arrivalDate() {
                this.$nextTick(this.computeTooltipAnchor);
            }
        },
        mounted() {
            var guestQuota = this.search.guestOccupancies[+(this.leg) - 1];

            var payload = {
                sessionId: this.session.Id,
                arrivalDate: this.seedDate.format('YYYY-MM-DD'),
                numberOfNights: 7,
                code: this.search.code,
                roomCode: this.roomType.PMSCode,
                rateCode: this.roomType.CalendarDefaultRate,
                guestOccupancies: [guestQuota],
                leg: this.leg,
                voucherCodes: this.search.voucherCodes
            };

            store.dispatch('fetchCalendar', payload);
            window.addEventListener('resize', this.computeTooltipAnchor);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.computeTooltipAnchor);
        },
        methods: {
            isArrivalDate: function (date) {
                return this.arrivalDate.isSame(moment(date), 'day');
            },
            computeTooltipAnchor() {
                if (!this.arrivalMlos || this.arrivalDayIndex < 0 || !this.$refs.calendarUl) {
                    this.tooltipAnchor = null;
                    return;
                }
                const li = this.$refs.calendarUl.children[this.arrivalDayIndex];
                if (!li) { this.tooltipAnchor = null; return; }
                const rect = li.getBoundingClientRect();
                this.tooltipAnchor = {
                    top: rect.top + window.scrollY - 6,
                    left: rect.left + window.scrollX + rect.width / 2,
                    width: rect.width
                };
            },
            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            },
            formatDate: function (date) {
                return moment(date).format("DD/MM/YYYY")
            },
            onCalendarNext: function () {
                var guestQuota = this.search.guestOccupancies[+(this.leg) - 1];

                var minDate = moment.min(this.calendarDays.map(x => moment(x.Date)));
                var arrivalDate = minDate.add(7, 'd');
                var payload = {
                    sessionId: this.session.Id,
                    arrivalDate: arrivalDate.format('YYYY-MM-DD'),
                    numberOfNights: 7,
                    roomCode: this.roomType.PMSCode,
                    rateCode: this.roomType.CalendarDefaultRate,
                    guestOccupancies: [guestQuota],
                    leg: this.leg,
                };

                store.dispatch('fetchCalendar', payload);
            },
            onCalendarPrev: function () {
                var guestQuota = this.search.guestOccupancies[+(this.leg) - 1];

                var minDate = moment.min(this.calendarDays.map(x => moment(x.Date)));
                var arrivalDate = minDate.add(-7, 'd');
          
                var payload = {
                    sessionId: this.session.Id,
                    arrivalDate: arrivalDate.format('YYYY-MM-DD'),
                    numberOfNights: 7,
                    roomCode: this.roomType.PMSCode,
                    rateCode: this.roomType.CalendarDefaultRate,
                    guestOccupancies: [guestQuota],
                    leg: this.leg,
                };

                store.dispatch('fetchCalendar', payload);
            },
            getCssClass: function (calDay) {
                let thisDate = moment(calDay.Date);


                let result = '';

                if (!this.isEnabled) {
                    result += 'disabled ';
                }

                if (calDay.IsClosed) {
                    result += 'unavailable ';
                }
               
                if (thisDate.isBetween(this.arrivalDate, this.departureDate)
                    || thisDate.isSame(this.arrivalDate)) {
                    result += 'stay ';
                }
                if (thisDate.isSame(this.departureDate)) {
                    result += 'checkout ';
                }

                return result;

            },
            onClickDate: function (date) {
                if (!this.isEnabled) {
                    return;
                }

                let existingSearch = this.search;

                var mArrivalDate = moment(date);
                var mDepartureDate = mArrivalDate.clone().add(+existingSearch.numberOfNights, 'd');

                this.newArrivalDate = mArrivalDate.format('YYYY-MM-DD');
                this.newDepartureDate = mDepartureDate.format('YYYY-MM-DD');

                var search = {
                    sessionId: existingSearch.sessionId,
                    guestOccupancies: existingSearch.guestOccupancies,
                    code: existingSearch.code,
                    arrivalDate: this.newArrivalDate,
                    numberOfNights: existingSearch.numberOfNights,
                };

                let bookingPayload = {
                    monetaryVouchers: this.booking.vouchers
                };

                store.dispatch("clearPartialData").then(() => {
                    store.dispatch('setSearch', search).then(() => {
                        store.dispatch('createBooking', bookingPayload);
                        store.dispatch('searchRooms', this.search);
                    })
                });
            }
        },

    }



</script>

<style scoped>
    .calendar-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 60px;
        width: 100%;
    }

    .calendar-spinner {
        width: 24px;
        height: 24px;
        border: 3px solid rgba(0, 0, 0, 0.15);
        border-top-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        animation: calendar-spin 0.7s linear infinite;
    }

    @keyframes calendar-spin {
        to { transform: rotate(360deg); }
    }

    .calendar-mlos {
        position: absolute;
        transform: translateX(-50%) translateY(-100%);
        background: #425260;
        color: #fff;
        font-size: 10px;
        font-weight: 600;
        padding: 4px 8px;
        border-radius: 3px;
        text-align: center;
        line-height: 1.4;
        max-width: 100px;
        white-space: normal;
        pointer-events: none;
        z-index: 9999;
    }

        .calendar-mlos::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border: 4px solid transparent;
            border-top-color: #425260;
        }
</style>
